import React, { useRef, useEffect } from 'react';
import styles from './SampleQuestions.module.css';

export const sampleQuestions = [
  "What can you do?",
  "What were core KPIs last week vs the previous week?",
  "What were core KPIs at the end of last month vs the previous month?",
  "Which dispensers had the highest reboot rate last week?",
  "Which dispensers had the lowest beverage availability last week?",
  "Which Active and Enrolled dispensers have not reported a pour in 30 days?",
  "Which dispensers have the highest volume growth YTD vs PY?",
  "What were the top Promotional Beverages poured last week?"
];

export const stripHtmlTags = (text: string): string => {
  const div = document.createElement("div");
  div.innerHTML = text;
  return div.textContent || div.innerText || "";
};

// Define the types for the props
interface SampleQuestionsPopupProps {
  onClose: () => void; // Define the onClose function type
  onSelect: (question: string) => void; // Define the onSelect function type
}

const SampleQuestionsPopup: React.FC<SampleQuestionsPopupProps> = ({ onClose, onSelect }) => {
  const firstQuestionRef = useRef<HTMLLIElement | null>(null);

  useEffect(() => {
    if (firstQuestionRef.current) {
      firstQuestionRef.current.focus();
    }
  }, []);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      onClose(); // Close the popup on Escape key press
    }
  };

  return (
    <div
      className={styles.popupContainer}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="dialog"
      aria-modal="true">
      <div className={styles.popupContent}>
        <ul className={styles.sampleQuestionsList}>
          {sampleQuestions.map((question, index) => (
            <li
              key={index}
              onClick={() => {
                const plainTextQuestion = stripHtmlTags(question);
                onSelect(plainTextQuestion);
              }}
              className={styles.sampleQuestionItem}
              tabIndex={0}
              ref={index === 0 ? firstQuestionRef : null}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  const plainTextQuestion = stripHtmlTags(question);
                  onSelect(plainTextQuestion);
                }
              }}
              role="button"
              aria-label={`Select question: ${question}`}
              dangerouslySetInnerHTML={{ __html: question }}
            />
          ))}
        </ul>
        <button onClick={onClose} className={styles.closeButton}>Close</button>
      </div>
    </div>
  );
};

export default SampleQuestionsPopup;
